import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import HideAppBar from "../../widgets/header/HideAppBar";
import {
	Card,
	CardContent,
	CardHeader,
	Collapse,
	Container, FormControl,
	Grid, InputLabel, MenuItem,
	Paper, Select,
	TextField,
} from "@mui/material";
import clsx from "clsx";
import IntervisteDrawer from "./drawer/IntervisteDrawer";
import useGetAllInterviste from "./utils/useGetAllInterviste";
import {useHistory} from "react-router-dom";
import {onClickDetails} from "../../../services/AutomationServices";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AppContext} from "../../../App";
import IntervistaIncompletaCard from "./detail/IntervistaIncompletaCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import IntervistaCompletaCard from "./detail/IntervistaCompletaCard";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import {generateIntervista} from "../../../services/IntervistaServices";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../reducers/IntervistaReducer";

const GestioneInterviste = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const appContext = useContext(AppContext);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [state, dispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [stato, setStato] = useState("Complete");
	const [pageNumber, setPageNumber] = useState(0);
	const [value, setValue] = useState("");
	const [expanded, setExpanded] = useState(false)
	const [sort, setSort] = useState("dataUltimaModifica");
	const [dir, setDir] = useState("ASC");
	const [submitCompila, setSubmitCompila] = useState(false);
	const [tipoEntita, setTipoEntita] = useState("");
	const {loading, error, hasMore, interviste} = useGetAllInterviste(stato, pageNumber, null, sort, dir);
	const observer = useRef();
	
	const handleSearch = (e) => {
		setValue(e.target.value);
	}
	
	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, []);
	
	const history = useHistory();
	const [selected, setSelected] = useState("")
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore) {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore])
	
	const onClickIntervista = (intervista) => {
		setSelected(intervista);
		setTipoEntita(stato);
		if (stato === "In attesa") {
			setOpenSnackbar("info", "Attendi che il paziente la compili o riprendi il tampone positivo del paziente.", appContext.dispatch)
		} else if (stato === "Compilata cittadino") {
			onClickDetails(intervista.idCompleta, "intervista", "modify", automationDispatch);
		} else {
			onClickDetails(intervista.id, "intervista_incompleta", "modify", automationDispatch);
		}
	}
	
	const onClickCompleta = useCallback((intervista) => {
		setSelected(intervista);
		setTipoEntita("intervista");
		onClickDetails(intervista.id, "intervista", "modify", automationDispatch);
	}, [automationDispatch]);
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				if (tipoEntita === "Incomplete operatore" || tipoEntita === "In gestione INC") {
					let tags = selected.note?.match(/#(\S*)/g);
					history.push("/gestione/interviste/incompleta/" + selected.id + "/focolaio/" + selected.idFocolaio + "/soggetto/" + selected.idAnagraficaPazienteZero + "/" + tags[0].replace("#", "").replace(".", ""));
				} else if (tipoEntita === "Complete" || tipoEntita === "In gestione CMP" || tipoEntita === "intervista") {
					history.push("/gestione/interviste/" + selected.id);
				} else if (tipoEntita === "Compilata cittadino") {
					setSubmitCompila(true);
					generateIntervista({id: -100}, dispatch, selected.id)
				}
			} else {
				setOpenSnackbar("warning", ("L'intervista è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch, tipoEntita, dispatch])
	
	useEffect(() => {
		if (submitCompila && !state.loadingAddIntervistaIncompleta && state.errorAddIntervistaIncompleta === "") {
			setSubmitCompila(false);
			history.push("/gestione/interviste/" + selected.idCompleta);
		} else if (submitCompila && !state.loadingAddIntervistaIncompleta && state.errorAddIntervistaIncompleta !== "") {
			setSubmitCompila(false);
			setOpenSnackbar("error", state.errorAddIntervistaIncompleta, appContext.dispatch);
		}
	}, [submitCompila, state.loadingAddIntervistaIncompleta, state.errorAddIntervistaIncompleta, appContext.dispatch, history, selected])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Interviste"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						
						<Grid item xs={12}>
							<Paper
								className={clsx(classes.roundBorder)}
								component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale, categoria, operatore e molto altro"}
									value={value}
									onChange={handleSearch}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton color="inherit" size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="end">
											<Tooltip title={"Cerca"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => setExpanded(!expanded)}
                                                    className={clsx(classes.expand, {
                                                        [classes.expandOpen]: expanded,
                                                    })}
                                                    size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder},
									}}
								/>
								<Collapse in={expanded} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
													<MenuItem value={"dataCreazione"}>Data creazione</MenuItem>
													<MenuItem value={"codf"}>Codice fiscale</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>
						
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<IntervisteDrawer stato={stato} selectMenuItem={setMenuSelected}/>
									
									<div className={classes.content}>
										{
											interviste.map((intervista, index) => {
												if (interviste.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={intervista.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															{
																(stato.includes("Incomplete") || stato.includes("In gestione INC") || stato.includes("In attesa") || stato.includes("Compilata cittadino")) ?
																	<IntervistaIncompletaCard intervista={intervista}
																	                          onClickIntervista={onClickIntervista}/> :
																	<IntervistaCompletaCard intervista={intervista}
																	                        onClickIntervista={onClickCompleta}/>
															}
														</Card>
													)
												} else {
													return (
														<Card key={intervista.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															{
																(stato.includes("Incomplete") || stato.includes("In gestione INC") || stato.includes("In attesa cittadino") || stato.includes("Compilata cittadino")) ?
																	<IntervistaIncompletaCard intervista={intervista}
																	                          onClickIntervista={onClickIntervista}/> :
																	<IntervistaCompletaCard intervista={intervista}
																	                        onClickIntervista={onClickCompleta}/>
															}
														</Card>
													)
												}
											})
										}
										{!loading && !error && interviste.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono interviste! Goditi questo meritato relax
											</Alert>}
										{loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
									</div>
								
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
}

export default React.memo(GestioneInterviste);
